export default __webpack_public_path__ + "static/media/785.8a7303f5.gif";